/* eslint-disable angular/document-service */
angular.module('tgaAdmin').controller('HubAnalyticsController', [
  '$scope',
  '$state',
  '$timeout',
  'gameService',
  'playerService',
  'statsService',
  'reportService',
  '$filter',
  '$uibModal',
  'localStorageService',
  'domainService',
  'modalService',
  'hubService',
  'customFieldService',
  'ngIntroService',
  'userService',
  'tzService',
  '$log',
  'settingsService',
  function (
    $scope,
    $state,
    $timeout,
    gameService,
    playerService,
    statsService,
    reportService,
    $filter,
    $uibModal,
    localStorageService,
    domainService,
    modalService,
    hubService,
    customFieldService,
    ngIntroService,
    userService,
    tzService,
    $log,
    settingsService,
  ) {
    $scope.data = {
      alerts: [],
      hub_id: $state.params.hub_id || null,
      game_id: $state.params.game_id || null,
      gameTypes: gameService.getGameTypes(),
      taskTypes: hubService.getTaskTypes(),
      filedate: moment().format('YYYY-MM-DD HH-mm-ss'),
      separator: ',',
      decimalSeparator: '.',
      countupOptions: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      },
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day')
              || !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.$broadcast('updatedDatepickerRange');
              $scope.actions.loadChart();
              $scope.actions.loadChallengesCustomFields();
              $scope.actions.loadSpinData();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
      // @TODO find a way to get this from the SCSS, as custom colors should override these
      themeColors: {
        pink: '#F16F84',
        purple: '#9691CC',
        blue: '#4E92D8',
      },
      chartOptions: {
        colors: ['#F16F84', '#9691CC', '#4E92D8'],
        series: [
          {
            name: 'Game Plays',
            data: [],
          },
          {
            name: 'Players',
            data: [],
          },
        ],
        chart: {
          width: '100%',
          height: 200,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetY: 15,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 4,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: 0,
            style: {
              fontSize: '13px',
            },
          },
        },
        yaxis: [
          {
            seriesName: 'Game Plays',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#F16F84',
            },
            labels: {
              style: {
                colors: '#F16F84',
                fontSize: '13px',
              },
              formatter(val) {
                return Math.floor(val);
              },
            },
            title: {
              text: 'Game Plays',
              style: {
                color: '#F16F84',
                fontSize: '13px',
              },
            },
          },
          {
            seriesName: 'Players',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#9691CC',
            },
            labels: {
              style: {
                colors: '#9691CC',
                fontSize: '13px',
              },
              formatter(val) {
                return Math.floor(val);
              },
            },
            title: {
              text: 'Players',
              style: {
                color: '#9691CC',
                fontSize: '13px',
              },
            },
          },
        ],
      },
      strikeOptions: {
        colors: ['#ffffff'],
        series: [
          {
            data: [],
          },
        ],
        chart: {
          width: '100%',
          height: 64,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
          },
          sparkline: {
            enabled: true,
          },
        },
        stroke: {
          curve: 'straight',
          width: 2,
          dashArray: 2,
        },
        tooltip: {
          enabled: false,
        },
      },
    };

    $scope.viewmodel = {
      hub: {},
      spinData: [],
      players: [],
      custom_fields: [],
      highScore: 0,
      totalSessions: 0,
      avgTime: 0,
      playerPrizes: [],
      challengesIssued: 0,
      challengesComplete: 0,
      showChart: true,
      games: [],
      ratings: [],
      questions: [],
      journeys: [],
      range: 'Last 30 Days',
      oldRange: {
        startDate: moment()
          .subtract(29, 'days')
          .startOf('day'),
        endDate: moment().endOf('day'),
      },
      dateRange: {
        startDate: moment()
          .subtract(29, 'days')
          .startOf('day'),
        endDate: moment().endOf('day'),
      },
      statPanels: {
        accuracy: {
          active: false,
          answers: 0,
        },
        topTenLists: {
          active: false,
          selected: 'top_games',
          labels: [],
          description: '',
          list: [],
        },
        engagement: {
          active: false,
          players: 0,
          games: 0,
          avgPlayTime: 0,
          strikeOptions: { ...$scope.data.strikeOptions },
          chartOptions: { ...$scope.data.chartOptions },
        },
        leaderboards: {
          active: false,
          selected: null,
          title: 'Global XP Leaderboard',
          totalXp: 0,
          avgXp: 0,
          list: [],
        },
        soloGames: {
          active: false,
          plays: 0,
          xpEarned: 0,
          strikeOptions: { ...$scope.data.strikeOptions },
          chartOptions: { ...$scope.data.chartOptions },
        },
        battles: {
          active: false,
          plays: 0,
          xpEarned: 0,
          strikeOptions: { ...$scope.data.strikeOptions },
          chartOptions: { ...$scope.data.chartOptions },
        },
        users: {
          active: false,
          unique: 0,
          totalLogins: 0,
          strikeOptions: { ...$scope.data.strikeOptions },
          chartOptions: { ...$scope.data.chartOptions },
        },
        spinToWin: {
          active: false,
          totalSpins: 0,
          totalXp: 0,
          totalLarge: 0,
          totalSmall: 0,
          totalNothing: 0,
        },
      },
    };

    $scope.initialize = function () {
      // New features
      userService.getData('featurePrize').then((val) => {
        if (!val) {
          $timeout(() => {
            ngIntroService.clear();
            ngIntroService.setOptions({
              steps: [
                {
                  element: '#aside [ui-sref="v1.hub.prizes"]',
                  intro:
                    // eslint-disable-next-line max-len
                    '<h5 style="margin-top: 0;" class="text-warning"><span class="fa fa-star"></span> New Feature</h5>Add prizes to increase engagement and incentivize users to play, compete & learn!',
                  position: 'right',
                },
              ],
              showStepNumbers: false,
              showBullets: false,
              showProgress: false,
              scrollToElement: true,
              scrollPadding: 200,
              exitOnOverlayClick: false,
              exitOnEsc: false,
              nextLabel: 'Next',
              prevLabel: 'Previous',
              skipLabel: 'Exit',
              doneLabel: 'Got it!',
              tooltipClass: 'single-button',
            });
            ngIntroService.start();

            ngIntroService.onExit(() => {
              userService.setData('featurePrize', true);
            });
          }, 500);
        }
      });

      hubService
        .getHub($scope.data.hub_id)
        .then((hub) => {
          $scope.viewmodel.hub = hub;
          $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Analytics`;

          $scope.viewmodel.hub.games = $scope.viewmodel.hub.activities.filter(
            (game) => game.game_id && game.game_id > 0,
          );

          $scope.actions.loadChart();
          $scope.actions.loadChallengesCustomFields();
          $scope.actions.loadSpinData();
        })
        .catch((error) => {
          $log.log('err', error);
        });
    };

    $scope.actions = {
      scaleData(row) {
        let left = 0;
        let right = 0;
        let num = 0;
        const sizeMap = [50, 50, 50, 50, 50, 50, 48, 40, 35, 30, 27]; // px width, 0 to 10 digits
        const max = 10; // support for up to 18: [24, 22, 20, 18, 17, 16, 15, 14]
        const numDigits = (number) => `${number}`.replace('.', '').length;
        if (row === 'leaderboards') {
          left = numDigits($scope.viewmodel.statPanels.leaderboards.totalXp);
          right = numDigits($scope.viewmodel.statPanels.leaderboards.avgXp);
        } else if (row === 'soloGames') {
          left = numDigits($scope.viewmodel.statPanels.soloGames.plays);
          right = numDigits($scope.viewmodel.statPanels.soloGames.xpEarned);
        } else if (row === 'battles') {
          left = numDigits($scope.viewmodel.statPanels.battles.plays);
          right = numDigits($scope.viewmodel.statPanels.battles.xpEarned);
        } else if (row === 'users') {
          left = numDigits($scope.viewmodel.statPanels.users.unique);
          right = numDigits($scope.viewmodel.statPanels.users.totalLogins);
        } else if (row === 'spinToWin') {
          left = numDigits($scope.viewmodel.statPanels.spinToWin.totalSpins);
          right = numDigits($scope.viewmodel.statPanels.spinToWin.totalXp);
        } else {
          left = right = 0;
        }
        if (left > max || right > max) {
          num = max;
        } else if (left >= right) {
          num = left;
        } else {
          num = right;
        }
        return `${sizeMap[num]}px`;
      },
      calcLeaderRowWidths(leaders) {
        if (!leaders.length) {
          return;
        }

        const maxW = 100;
        const minW = 30;

        // eslint-disable-next-line prefer-spread
        const maxValue = Math.max.apply(
          Math,
          leaders.map((o) => o.points),
        ) || 1;
        for (let i = 0; i < leaders.length; i++) {
          leaders[i].width = `${(maxW * leaders[i].points) / maxValue
            + (minW * (maxValue - leaders[i].points)) / maxValue}%`;
        }
      },
      buildStrikeChartOptions(seriesObj) {
        const opts = {
          series: [{ data: seriesObj.data }],
          colors: ['#ffffff'],
        };
        return { ...$scope.data.strikeOptions, ...opts };
      },
      buildPanelChartOptions(seriesData) {
        const opts = { yaxis: [], series: [], colors: [] };
        for (let i = 0; i < seriesData.length; i++) {
          if (seriesData[i].is_time) {
            opts.yaxis.push({
              seriesName: seriesData[i].name,
              opposite: i === 1,
              axisTicks: { show: true },
              axisBorder: { show: true, color: seriesData[i].color },
              labels: {
                style: { colors: seriesData[i].color, fontSize: '13px' },
                formatter(val) {
                  return $scope.actions.formatTime(val);
                },
              },
              title: { text: seriesData[i].name, style: { color: seriesData[i].color, fontSize: '13px' } },
            });
          } else {
            opts.yaxis.push({
              seriesName: seriesData[i].name,
              opposite: i === 1,
              axisTicks: { show: true },
              axisBorder: { show: true, color: seriesData[i].color },
              labels: {
                style: { colors: seriesData[i].color, fontSize: '13px' },
                formatter(val) {
                  return Math.floor(val);
                },
              },
              title: { text: seriesData[i].name, style: { color: seriesData[i].color, fontSize: '13px' } },
            });
          }
          opts.series.push({ name: seriesData[i].name, data: seriesData[i].data });
          opts.colors.push(seriesData[i].color);
        }
        return { ...$scope.data.chartOptions, ...opts };
      },
      togglePanelActive(key) {
        Object.keys($scope.viewmodel.statPanels).forEach((i) => {
          if (i !== key) {
            $scope.viewmodel.statPanels[i].active = false;
          }
        });

        if ($scope.viewmodel.statPanels[key]) {
          $scope.viewmodel.statPanels[key].active = !$scope.viewmodel.statPanels[key].active;
        }
      },
      formatTime(time) {
        const h = Math.floor(time / 1000 / 3600);
        const m = Math.floor((time / 1000 - h * 3600) / 60);
        const s = Math.floor(time / 1000 - h * 3600 - m * 60);
        return `${(h ? `${h}:${m < 10 ? '0' : ''}` : '') + m}:${s < 10 ? `0${s}` : s}`;
      },
      loadChart() {
        statsService
          .getGlobalGameStats(
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
            $scope.data.hub_id,
          )
          .then((response) => {
            const avg_time = $filter('formatDuration')(response.average_time).split(':');
            response.average_time = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
            response.average_accuracy *= 100;
            $scope.viewmodel.globalGameStats = response;

            if (response.first_date) {
              $scope.data.datePickerOptions.ranges['All Time'] = [
                moment(response.first_date).startOf('month'),
                moment(),
              ];
            }
          });

        $scope.loadingChart = true;

        statsService
          .getOverviewChart(
            null,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
            $scope.data.hub_id,
          )
          .then((response) => {
            // Main chart
            $scope.data.chartOptions.series = [
              {
                name: 'Game Plays',
                data: response.sessions,
              },
              {
                name: 'Players',
                data: response.players,
              },
            ];

            $scope.data.chartOptions.xaxis.categories = response.xaxis;

            $scope.viewmodel.statPanels.accuracy.answers = response.totals.average_accuracy * 100;

            // Engagement
            const series = [
              { name: 'Game Plays', color: $scope.data.themeColors.blue, data: response.sessions },
              {
                name: 'Play Time',
                color: $scope.data.themeColors.pink,
                data: response.time,
                is_time: true,
              },
            ];

            $scope.viewmodel.statPanels.engagement.chartOptions = $scope.actions.buildPanelChartOptions(series);

            $scope.viewmodel.statPanels.engagement.chartOptions.xaxis.categories = response.xaxis;

            $scope.viewmodel.statPanels.engagement.strikeOptions.series = [
              {
                data: response.players,
              },
            ];

            $scope.viewmodel.statPanels.engagement.players = response.totals.total_players;
            $scope.viewmodel.statPanels.engagement.games = response.totals.total_games;
            $scope.viewmodel.statPanels.engagement.avgPlayTime = response.totals.average_time;

            $scope.loadingChart = false;
          });

        statsService
          .getArcadeStats({
            hub_id: $scope.data.hub_id,
            start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
            end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
          })
          .then((response) => {
            // Solo
            let series = [
              { name: 'Game Plays', color: $scope.data.themeColors.purple, data: response.solo.sessions },
              { name: 'XP Earned', color: $scope.data.themeColors.pink, data: response.solo.reward },
            ];

            $scope.viewmodel.statPanels.soloGames.chartOptions = $scope.actions.buildPanelChartOptions(series);

            $scope.viewmodel.statPanels.soloGames.chartOptions.xaxis.categories = response.xaxis;

            $scope.viewmodel.statPanels.soloGames.strikeOptions.series = [
              {
                data: response.solo.reward,
              },
            ];

            $scope.viewmodel.statPanels.soloGames.plays = response.solo.totals.total_sessions;
            $scope.viewmodel.statPanels.soloGames.xpEarned = response.solo.totals.total_reward;

            // Battles
            series = [
              { name: 'Game Plays', color: $scope.data.themeColors.purple, data: response.challenge.sessions },
              { name: 'XP Earned', color: $scope.data.themeColors.pink, data: response.challenge.reward },
            ];
            $scope.viewmodel.statPanels.battles.chartOptions = $scope.actions.buildPanelChartOptions(series);

            $scope.viewmodel.statPanels.battles.chartOptions.xaxis.categories = response.xaxis;

            $scope.viewmodel.statPanels.battles.strikeOptions.series = [
              {
                data: response.challenge.reward,
              },
            ];

            $scope.viewmodel.statPanels.battles.plays = response.challenge.totals.total_sessions;
            $scope.viewmodel.statPanels.battles.xpEarned = response.challenge.totals.total_reward;

            // Users
            series = [
              { name: 'Unique Users', color: $scope.data.themeColors.blue, data: response.users.unique },
              { name: 'Total Logins', color: $scope.data.themeColors.pink, data: response.users.logins },
            ];
            $scope.viewmodel.statPanels.users.chartOptions = $scope.actions.buildPanelChartOptions(series);

            $scope.viewmodel.statPanels.users.chartOptions.xaxis.categories = response.xaxis;

            $scope.viewmodel.statPanels.users.strikeOptions.series = [
              {
                data: response.users.logins,
              },
            ];

            $scope.viewmodel.statPanels.users.unique = response.users.totals.total_users;
            $scope.viewmodel.statPanels.users.totalLogins = response.users.totals.total_logins;
          });

        $scope.actions.loadTopTenList();
        $scope.actions.loadLeaderboard();
      },
      loadTopTenList() {
        $scope.loadingTopTen = true;

        statsService
          .getTopCharts({
            list_type: $scope.viewmodel.statPanels.topTenLists.selected,
            start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
            end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
            hub_id: $scope.data.hub_id,
            limit: 10,
          })
          .then((response) => {
            $scope.viewmodel.statPanels.topTenLists.list = response.list;
            $scope.actions.calcLeaderRowWidths($scope.viewmodel.statPanels.topTenLists.list);

            switch ($scope.viewmodel.statPanels.topTenLists.selected) {
              case 'top_games':
                $scope.viewmodel.statPanels.topTenLists.labels = ['Game', 'Plays'];
                $scope.viewmodel.statPanels.topTenLists.description = 'Games with the most plays.';
                break;
              case 'most_replays':
                $scope.viewmodel.statPanels.topTenLists.labels = ['Game', 'Replays'];
                $scope.viewmodel.statPanels.topTenLists.description = 'Games with the most replays.';
                break;
              case 'hardest_questions':
                $scope.viewmodel.statPanels.topTenLists.labels = ['Question', '% Correct'];
                $scope.viewmodel.statPanels.topTenLists.description = 'Questions taking the most attempts before getting correct.';
                break;
              case 'easiest_questions':
                $scope.viewmodel.statPanels.topTenLists.labels = ['Question', '% Correct'];
                $scope.viewmodel.statPanels.topTenLists.description = 'Questions answered correct most often.';
                break;
              default:
                $scope.viewmodel.statPanels.topTenLists.labels = [];
                $scope.viewmodel.statPanels.topTenLists.description = '';
                break;
            }

            $scope.loadingTopTen = false;
          });
      },
      loadLeaderboard() {
        $scope.loadingLeaderboard = true;

        if ($scope.viewmodel.statPanels.leaderboards.selected === null) {
          hubService.getLeaderboard().then((response) => {
            $scope.viewmodel.statPanels.leaderboards.list = response.list;
            $scope.viewmodel.statPanels.leaderboards.totalXp = response.total_xp;
            $scope.viewmodel.statPanels.leaderboards.avgXp = response.average_xp;
            $scope.viewmodel.statPanels.leaderboards.title = 'Global XP Leaderboard';
            $scope.actions.calcLeaderRowWidths($scope.viewmodel.statPanels.leaderboards.list);
            $scope.loadingLeaderboard = false;
          });
        } else {
          statsService
            .getLeaderboard({
              game_id: $scope.viewmodel.statPanels.leaderboards.selected.game_id,
              hub_id: $scope.data.hub_id,
              limit: 10,
            })
            .then((response) => {
              $scope.viewmodel.statPanels.leaderboards.list = response;
              $scope.viewmodel.statPanels.leaderboards.title = `${$scope.viewmodel.statPanels.leaderboards.selected.name} Leaderboard`;
              $scope.actions.calcLeaderRowWidths($scope.viewmodel.statPanels.leaderboards.list);
              $scope.loadingLeaderboard = false;
            });
        }
      },
      getPagedParams(tableState, extras = {}) {
        const params = tableState
          ? {
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            order: tableState.sort.reverse ? 'desc' : 'asc',
            hub_id: $scope.data.hub_id,
            start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
            end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
            stats: true,
          }
          : {};

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            // Check for divisions first and set values to a divisions array
            if (key === 'divisions') {
              params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
              );
            } else {
              params[key] = tableState.search.predicateObject[key];
            }
          });
        }

        angular.extend(params, extras);

        return params;
      },
      resetDateRange() {
        $scope.viewmodel.range = 'Last 30 Days';
        $scope.viewmodel.oldRange = {
          startDate: moment()
            .subtract(29, 'days')
            .startOf('day'),
          endDate: moment().endOf('day'),
        };
        $scope.viewmodel.dateRange = {
          startDate: moment()
            .subtract(29, 'days')
            .startOf('day'),
          endDate: moment().endOf('day'),
        };
        $scope.$broadcast('updatedDatepickerRange');
      },
      loadUsers(tableState) {
        $scope.loadingUsers = true;

        hubService.getPagedPlayers($scope.actions.getPagedParams(tableState)).then((response) => {
          $scope.viewmodel.players = response.items || response;
          $scope.loadingUsers = false;
          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      loadChallengesCustomFields() {
        const startDate = $scope.viewmodel.dateRange.startDate.toISOString(true);
        const endDate = $scope.viewmodel.dateRange.endDate.toISOString(true);

        hubService.getChallengeStats($scope.data.hub_id, startDate, endDate).then((response) => {
          $scope.viewmodel.challengesIssued = response.issued;
          $scope.viewmodel.challengesComplete = response.completed;
        });

        customFieldService.getCustomFields({ hub_id: $scope.data.hub_id }).then((customFields) => {
          $scope.viewmodel.custom_fields = customFields;
        });
      },
      loadGames(tableState) {
        $scope.loadingGames = true;

        hubService
          .getPagedActivityStats($scope.actions.getPagedParams(tableState, { ratings_only: false }))
          .then((response) => {
            $scope.viewmodel.games = response.items || response;
            $scope.loadingGames = false;
            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }
          });
      },
      loadRatings(tableState) {
        $scope.loadingRatings = true;

        // only load the activity types which support ratings.
        hubService
          .getPagedActivityStats($scope.actions.getPagedParams(tableState, { ratings_only: true }))
          .then((response) => {
            $scope.viewmodel.ratings = response.items || response;

            $scope.loadingRatings = false;
            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }
          });
      },
      loadJourneys(tableState) {
        $scope.loadingJourneys = true;

        hubService.getJourneys($scope.actions.getPagedParams(tableState)).then((response) => {
          $scope.viewmodel.journeys = response.items || response;
          $scope.loadingJourneys = false;
          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      loadMissions(tableState) {
        $scope.loadingMissions = true;

        hubService.getMissions($scope.actions.getPagedParams(tableState)).then((response) => {
          $scope.viewmodel.missions = response.items || response;
          $scope.loadingMissions = false;
          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      loadPrizes(tableState) {
        $scope.loadingPrizes = true;

        hubService.getPagedHubPrizes($scope.actions.getPagedParams(tableState)).then((response) => {
          $scope.viewmodel.playerPrizes = response.items || response;
          $scope.loadingPrizes = false;
          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }
        });
      },
      loadSpinData() {
        $scope.loadingSpinData = true;
        hubService
          .getHubSpinData(
            $scope.data.hub_id,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            $scope.viewmodel.spinData = response;
            $scope.viewmodel.statPanels.spinToWin.totalSpins = response.total_spins;
            $scope.viewmodel.statPanels.spinToWin.totalXp = response.total_xp;
            $scope.viewmodel.statPanels.spinToWin.totalLarge = response.total_large_steps;
            $scope.viewmodel.statPanels.spinToWin.totalSmall = response.total_small_steps;
            $scope.viewmodel.statPanels.spinToWin.totalNothing = response.total_nothing;
            $scope.loadingSpinData = false;
          });
      },
      showCourses(journey) {
        $scope.viewmodel.journey = journey;
        $scope.viewmodel.showCourses = true;
        angular.element('body').addClass('modal-open');
      },
      hideCourses() {
        $scope.viewmodel.journey = null;
        $scope.viewmodel.showCourses = false;
        angular.element('body').removeClass('modal-open');
      },
      showCourse(course) {
        $scope.viewmodel.course = course;
      },
      hideCourse() {
        $scope.viewmodel.course = null;
      },
      showJourneyPlayers(journey) {
        $scope.viewmodel.showPlayers = true;
        $scope.viewmodel.journey = journey;
        $scope.viewmodel.journey_players = journey.courses;
        angular.element('body').addClass('modal-open');
      },
      hideJourneyPlayers() {
        $scope.viewmodel.journey = null;
        $scope.viewmodel.journey_players = null;
        $scope.viewmodel.showPlayers = false;
        angular.element('body').removeClass('modal-open');
      },
      showJourneyPlayer(player) {
        $scope.viewmodel.selectedPlayer = player;
      },
      hideJourneyPlayer() {
        $scope.viewmodel.selectedPlayer = null;
      },
      showPlayerCourse(course) {
        $scope.viewmodel.selectedPlayer.course = course;
      },
      hidePlayerCourse() {
        $scope.viewmodel.selectedPlayer.course = null;
      },
      showPlayerMission(player, course) {
        $scope.viewmodel.selectedPlayer = player;
        $scope.viewmodel.selectedPlayer.course = course;
      },
      hidePlayerMission() {
        $scope.viewmodel.selectedPlayer = null;
        $scope.viewmodel.selectedPlayer.course = null;
      },
      exportPlayerStats(noDate) {
        if (!$scope.viewmodel.players.length) {
          return false;
        }

        let startDate = $scope.viewmodel.dateRange.startDate
          ? $scope.viewmodel.dateRange.startDate.toISOString(true)
          : null;
        let endDate = $scope.viewmodel.dateRange.endDate ? $scope.viewmodel.dateRange.endDate.toISOString(true) : null;

        if (noDate) {
          startDate = endDate = null;
        }

        $scope.exporting = true;

        return hubService.getPlayers($scope.data.hub_id, startDate, endDate, true).then((players) => {
          hubService.getSessionsReport($scope.data.hub_id, startDate, endDate).then((sessions) => {
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'The Training Arcade';

            // Overview
            let worksheet = workbook.addWorksheet('Overview (All Time)');

            // add column headers
            let header = [
              { header: 'Player', key: 'player', width: 12 },
              { header: 'Player ID', key: 'username', width: 12 },
              { header: 'Rank', key: 'rank', width: 12 },
              { header: 'Current Level', key: 'level', width: 12 },
              { header: 'XP', key: 'reward_total', width: 12 },
              { header: 'Total Sessions', key: 'total_sessions', width: 12 },
              { header: 'Completed Sessions', key: 'total_completed_sessions', width: 12 },
              { header: 'Total Time', key: 'total_time', width: 12 },
              { header: 'Total Time (Seconds)', key: 'total_time_seconds', width: 12 },
            ];

            if ($scope.viewmodel.custom_fields.length) {
              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                header.push({
                  header: $scope.viewmodel.custom_fields[i].label,
                  key: `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`,
                });
              }
            }

            worksheet.columns = header;

            for (let j = 0; j < players.length; j++) {
              const total_time = $filter('formatDuration')(players[j].total_time).split(':');

              const rowData = {
                player: players[j].full_name ? players[j].full_name : players[j].display_name,
                username: players[j].username,
                rank: players[j].rank,
                level: players[j].level,
                reward_total: players[j].reward_total,
                total_sessions: players[j].total_sessions,
                total_completed_sessions: players[j].total_completed_sessions,
                total_time: {
                  formula: `TIME(${total_time[0]},${total_time[1]},${total_time[2]}) + INT(${total_time[0]}/ 24)`,
                },
                total_time_seconds: Math.floor(players[j].total_time / 1000),
              };

              if ($scope.viewmodel.custom_fields.length) {
                for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                  if (
                    players[j].custom_fields
                    && players[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`]
                  ) {
                    // eslint-disable-next-line max-len
                    rowData[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`] = players[j].custom_fields[
                      `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`
                    ].text;
                  }
                }
              }

              worksheet.addRow(rowData);
            }

            worksheet.getColumn(8).numFmt = '[h]:mm:ss';
            worksheet.getColumn(9).numFmt = null;
            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // Sessions
            if (startDate) {
              worksheet = workbook.addWorksheet('Sessions');
            } else {
              worksheet = workbook.addWorksheet('Sessions (All Time)');
            }

            // add column headers
            header = [
              { header: 'Activity Type', key: 'activity_type', width: 12 },
              { header: 'Activity Name', key: 'activity_name', width: 12 },
              { header: 'Session ID', key: 'session_id', width: 12 },
              { header: 'Player', key: 'display_name', width: 12 },
              { header: 'Player ID', key: 'username', width: 12 },
              { header: 'First Name', key: 'first_name', width: 12 },
              { header: 'Last Name', key: 'last_name', width: 12 },
              { header: 'Team Name', key: 'team_name', width: 12 },
              { header: 'Date', key: 'date_created', width: 12 },
              { header: 'Duration', key: 'duration', width: 12 },
              { header: 'Duration (Seconds)', key: 'duration_seconds', width: 12 },
              { header: 'Score', key: 'points', width: 12 },
              { header: 'Total Questions', key: 'total_answered', width: 12 },
              { header: 'Total Correct', key: 'total_correct', width: 12 },
              { header: 'Total Incorrect', key: 'total_incorrect', width: 12 },
              { header: 'Correct %', key: 'accuracy', width: 12 },
            ];

            if ($scope.viewmodel.custom_fields.length) {
              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                header.push({
                  header: $scope.viewmodel.custom_fields[i].label,
                  key: `custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`,
                });
              }
            }

            worksheet.columns = header;

            for (let j = 0; j < sessions.length; j++) {
              const duration = $filter('formatDuration')(sessions[j].time).split(':');

              const rowData = {
                activity_type: $filter('activitySubtype')(sessions[j].activity_type),
                activity_name: sessions[j].activity_name,
                session_id: sessions[j].session_id,
                display_name: sessions[j].display_name,
                username: sessions[j].username,
                first_name: sessions[j].first_name,
                last_name: sessions[j].last_name,
                team_name: sessions[j].team_name,
                date_created: tzService.parseFormatUserDate(sessions[j].date_created, 'YYYY-MM-DD HH:mm:ss'),
                duration: { formula: `TIME(${duration[0]},${duration[1]},${duration[2]}) + INT(${duration[0]}/ 24)` },
                duration_seconds: Math.floor(sessions[j].time / 1000),
                points: sessions[j].points,
                total_answered: sessions[j].total_answered,
                total_correct: sessions[j].total_correct,
                total_incorrect: sessions[j].total_incorrect,
                accuracy:
                  sessions[j].total_correct > 0
                    ? sessions[j].total_correct / (sessions[j].total_answered || 1)
                    : sessions[j].accuracy,
              };

              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                if (
                  sessions[j].custom_fields
                  && sessions[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`]
                ) {
                  // eslint-disable-next-line max-len
                  rowData[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`] = sessions[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`].text;
                }
              }

              worksheet.addRow(rowData);
            }

            worksheet.getColumn(10).numFmt = '[h]:mm:ss';
            worksheet.getColumn(11).numFmt = null;
            worksheet.getColumn(16).numFmt = '0.00%';

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // Teams
            if (startDate) {
              worksheet = workbook.addWorksheet('Teams');
            } else {
              worksheet = workbook.addWorksheet('Teams (All Time)');
            }

            // add column headers
            header = [
              { header: 'Game Type', key: 'game_type', width: 12 },
              { header: 'Game Name', key: 'game_name', width: 12 },
              { header: 'Team Name', key: 'team_name', width: 12 },
              { header: 'Rank', key: 'rank', width: 12 },
              { header: 'Score', key: 'points', width: 12 },
            ];

            worksheet.columns = header;

            $scope.viewmodel.games.forEach((game) => {
              if (!game.team_field_id) {
                return;
              }

              game.teams.forEach((team) => {
                const rowData = {
                  game_type: $filter('gameType')(game.game_type),
                  game_name: game.name,
                  team_name: team.display_name,
                  rank: team.rank,
                  points: team.points,
                };

                worksheet.addRow(rowData);
              });
            });

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [{ state: 'frozen', ySplit: 1 }];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // save workbook to disk
            workbook.xlsx
              .writeBuffer({ base64: true })
              .then((xls64) => {
                // build anchor tag and attach file (works in chrome)
                const a = document.createElement('a');
                const data = new Blob([xls64], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = URL.createObjectURL(data);
                a.href = url;
                a.download = reportService.generateReportFilename('Arcade Analytics', startDate, startDate, 'xlsx');
                document.body.appendChild(a);
                a.click();
                // eslint-disable-next-line angular/timeout-service
                setTimeout(() => {
                  document.body.removeChild(a);
                  // eslint-disable-next-line angular/window-service
                  window.URL.revokeObjectURL(url);
                }, 0);
              })
              .catch((error) => {
                $log.log(error.message);
              });

            $scope.exporting = false;
          });
        });
      },
      // eslint-disable-next-line consistent-return
      exportJourneyStats() {
        if (!$scope.viewmodel.players.length) {
          return false;
        }

        $scope.exporting = true;

        $timeout(() => {
          const workbook = new ExcelJS.Workbook();
          workbook.creator = 'The Training Arcade';

          /// //////////////////////////////
          // Journeys Overview
          /// /////
          let worksheet = workbook.addWorksheet('Journeys');

          // add column headers
          worksheet.columns = [
            { header: 'Name', key: 'name', width: 12 },
            { header: 'Stages', key: 'stages', width: 12 },
            { header: 'Activities', key: 'activities', width: 12 },
            { header: 'Sessions', key: 'sessions', width: 12 },
            { header: 'Players', key: 'players', width: 12 },
            { header: 'Accuracy', key: 'accuracy', width: 12 },
            { header: 'Avg. Time', key: 'avg_time', width: 12 },
          ];

          let row = 2;
          let collapseRows = [];

          $scope.viewmodel.journeys.forEach((journey) => {
            let avg_time = $filter('formatDuration')(journey.stats.average_time).split(':');
            let total_activities = 0;

            if (journey.courses.length) {
              for (let i = 0; i < journey.courses.length; i++) {
                total_activities += journey.courses[i].items.length;
              }
            }

            worksheet.addRow({
              name: journey.name,
              stages: journey.courses.length,
              activities: total_activities,
              sessions: journey.stats.total_sessions,
              players: journey.stats.total_players,
              accuracy: journey.stats.average_accuracy * 1,
              avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
            });

            row++;

            if (journey.courses.length) {
              collapseRows.push({ start: row, end: row + journey.courses.length + total_activities, level: 1 });

              journey.courses.forEach((course) => {
                avg_time = $filter('formatDuration')(course.stats.average_time).split(':');

                worksheet.addRow({
                  name: course.name,
                  activities: course.items.length,
                  sessions: course.stats.total_sessions,
                  players: course.stats.total_players,
                  accuracy: course.stats.average_accuracy * 1,
                  avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
                });

                row++;

                if (course.items.length) {
                  collapseRows.push({ start: row, end: row + course.items.length, level: 2 });

                  course.items.forEach((item) => {
                    avg_time = $filter('formatDuration')(item.stats.average_time).split(':');

                    worksheet.addRow({
                      name: `${item.name} (${$filter('courseItemType')(item.item_type)})`,
                      sessions: item.stats.total_sessions,
                      players: item.stats.total_players,
                      accuracy: item.stats.average_accuracy * 1,
                      avg_time: {
                        formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                      },
                    });

                    row++;
                  });
                }
              });
            }
          });

          collapseRows.forEach((collapseRow) => {
            for (let i = collapseRow.start; i < collapseRow.end; i++) {
              worksheet.getRow(i).outlineLevel = collapseRow.level;
            }
          });

          worksheet.getColumn(6).numFmt = '0.00%';
          worksheet.getColumn(7).numFmt = '[h]:mm:ss';

          worksheet.getRow(1).font = { bold: true };

          worksheet.views = [{ state: 'frozen', ySplit: 1 }];

          worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
          };

          // Overview
          worksheet = workbook.addWorksheet('Journey Players');

          // add column headers
          worksheet.columns = [
            { header: 'Name', key: 'name', width: 12 },
            { header: 'Player ID', key: 'username', width: 12 },
            { header: 'Players', key: 'players', width: 12 },
            { header: 'Stages', key: 'stages', width: 12 },
            { header: 'Activities', key: 'activities', width: 12 },
            { header: 'Sessions', key: 'sessions', width: 12 },
            { header: 'Accuracy', key: 'accuracy', width: 12 },
            { header: 'Avg. Time', key: 'avg_time', width: 12 },
            { header: 'Date', key: 'date_created', width: 12 },
          ];

          row = 2;
          collapseRows = [];

          $scope.viewmodel.journeys.forEach((journey) => {
            let avg_time = $filter('formatDuration')(journey.stats.average_time).split(':');
            let total_player_courses = 0;
            let total_player_activities = 0;

            if (journey.players.length) {
              for (let i = 0; i < journey.players.length; i++) {
                total_player_courses += journey.players[i].courses.length;

                for (let j = 0; j < journey.players[i].courses.length; j++) {
                  total_player_activities += journey.players[i].courses[j].items.length;
                }
              }
            }

            worksheet.addRow({
              name: journey.name,
              stages: total_player_courses,
              activities: total_player_activities,
              sessions: journey.stats.total_sessions,
              players: journey.stats.total_players,
              accuracy: journey.stats.average_accuracy * 1,
              avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
            });

            row++;

            if (journey.players.length) {
              collapseRows.push({
                start: row,
                end:
                  row
                  + journey.players.length
                  + total_player_courses
                  + total_player_activities
                  + journey.stats.total_sessions,
                level: 1,
              });

              journey.players.forEach((player) => {
                avg_time = $filter('formatDuration')(player.average_time).split(':');

                worksheet.addRow({
                  name: `${player.first_name} ${player.last_name}`,
                  username: player.username,
                  stages: player.total_stages,
                  activities: player.total_activities,
                  sessions: player.total_sessions,
                  accuracy: player.average_accuracy * 1,
                  avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
                });

                row++;

                if (player.courses.length) {
                  collapseRows.push({
                    start: row,
                    end: row + player.courses.length + player.total_activities + player.total_sessions,
                    level: 2,
                  });

                  player.courses.forEach((course) => {
                    avg_time = $filter('formatDuration')(course.stats.average_time).split(':');

                    worksheet.addRow({
                      name: course.name,
                      activities: course.items.length,
                      sessions: course.stats.total_sessions,
                      accuracy: course.stats.average_accuracy * 1,
                      avg_time: {
                        formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                      },
                    });

                    row++;

                    if (course.items.length) {
                      collapseRows.push({
                        start: row,
                        end: row + course.items.length + course.stats.total_sessions,
                        level: 3,
                      });

                      course.items.forEach((item) => {
                        avg_time = $filter('formatDuration')(item.stats.average_time).split(':');

                        worksheet.addRow({
                          name: `${item.name} (${$filter('courseItemType')(item.item_type)})`,
                          sessions: item.stats.total_sessions,
                          accuracy: item.stats.average_accuracy * 1,
                          avg_time: {
                            formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                          },
                        });

                        row++;

                        if (item.sessions.length) {
                          collapseRows.push({ start: row, end: row + item.sessions.length, level: 4 });
                          let sessionNumber = 1;

                          item.sessions.forEach((session) => {
                            avg_time = $filter('formatDuration')(session.time).split(':');

                            worksheet.addRow({
                              name: `Session ${sessionNumber}`,
                              accuracy: session.accuracy * 1,
                              avg_time:
                                session.time !== null
                                  ? {
                                    formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                                  }
                                  : null,
                              date_created: session.date_created,
                            });

                            sessionNumber++;
                            row++;
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });

          collapseRows.forEach((collapseRow) => {
            for (let i = collapseRow.start; i < collapseRow.end; i++) {
              worksheet.getRow(i).outlineLevel = collapseRow.level;
            }
          });

          worksheet.getColumn(7).numFmt = '0.00%';
          worksheet.getColumn(8).numFmt = '[h]:mm:ss';

          worksheet.getRow(1).font = { bold: true };

          worksheet.views = [{ state: 'frozen', ySplit: 1 }];

          worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
          };

          /// //////////////////////////////
          // Missions Overview
          /// /////
          worksheet = workbook.addWorksheet('Missions');

          // add column headers
          worksheet.columns = [
            { header: 'Name', key: 'name', width: 12 },
            { header: 'Activities', key: 'activities', width: 12 },
            { header: 'Sessions', key: 'sessions', width: 12 },
            { header: 'Players', key: 'players', width: 12 },
            { header: 'Accuracy', key: 'accuracy', width: 12 },
            { header: 'Avg. Time', key: 'avg_time', width: 12 },
          ];

          row = 2;
          collapseRows = [];

          $scope.viewmodel.missions.forEach((mission) => {
            let avg_time = $filter('formatDuration')(mission.stats.average_time).split(':');
            let total_activities = 0;

            if (mission.courses.length) {
              for (let i = 0; i < mission.courses.length; i++) {
                total_activities += mission.courses[i].items.length;
              }
            }

            worksheet.addRow({
              name: mission.name,
              activities: total_activities,
              sessions: mission.stats.total_sessions,
              players: mission.stats.total_players,
              accuracy: mission.stats.average_accuracy * 1,
              avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
            });

            row++;

            if (mission.courses.length) {
              collapseRows.push({ start: row, end: row + mission.courses.length + total_activities, level: 1 });

              mission.courses.forEach((course) => {
                if (course.items.length) {
                  collapseRows.push({ start: row, end: row + course.items.length, level: 2 });

                  course.items.forEach((item) => {
                    avg_time = $filter('formatDuration')(item.stats.average_time).split(':');

                    worksheet.addRow({
                      name: `${item.name} (${$filter('courseItemType')(item.item_type)})`,
                      sessions: item.stats.total_sessions,
                      players: item.stats.total_players,
                      accuracy: item.stats.average_accuracy * 1,
                      avg_time: {
                        formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                      },
                    });

                    row++;
                  });
                }
              });
            }
          });

          collapseRows.forEach((collapseRow) => {
            for (let i = collapseRow.start; i < collapseRow.end; i++) {
              worksheet.getRow(i).outlineLevel = collapseRow.level;
            }
          });

          worksheet.getColumn(5).numFmt = '0.00%';
          worksheet.getColumn(6).numFmt = '[h]:mm:ss';

          worksheet.getRow(1).font = { bold: true };

          worksheet.views = [{ state: 'frozen', ySplit: 1 }];

          worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
          };

          // Overview
          worksheet = workbook.addWorksheet('Mission Players');

          // add column headers
          worksheet.columns = [
            { header: 'Name', key: 'name', width: 12 },
            { header: 'Player ID', key: 'username', width: 12 },
            { header: 'Players', key: 'players', width: 12 },
            { header: 'Activities', key: 'activities', width: 12 },
            { header: 'Sessions', key: 'sessions', width: 12 },
            { header: 'Accuracy', key: 'accuracy', width: 12 },
            { header: 'Avg. Time', key: 'avg_time', width: 12 },
            { header: 'Date', key: 'date_created', width: 12 },
          ];

          row = 2;
          collapseRows = [];

          $scope.viewmodel.missions.forEach((mission) => {
            let avg_time = $filter('formatDuration')(mission.stats.average_time).split(':');
            let total_player_courses = 0;
            let total_player_activities = 0;

            if (mission.players.length) {
              for (let i = 0; i < mission.players.length; i++) {
                // eslint-disable-next-line no-unused-vars
                total_player_courses += mission.players[i].courses.length;

                for (let j = 0; j < mission.players[i].courses.length; j++) {
                  total_player_activities += mission.players[i].courses[j].items.length;
                }
              }
            }

            worksheet.addRow({
              name: mission.name,
              activities: total_player_activities,
              sessions: mission.stats.total_sessions,
              players: mission.stats.total_players,
              accuracy: mission.stats.average_accuracy * 1,
              avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
            });

            row++;

            if (mission.players.length) {
              collapseRows.push({
                start: row,
                end: row + mission.players.length + total_player_activities + mission.stats.total_sessions,
                level: 1,
              });

              mission.players.forEach((player) => {
                avg_time = $filter('formatDuration')(player.average_time).split(':');

                worksheet.addRow({
                  name: `${player.first_name} ${player.last_name}`,
                  username: player.username,
                  activities: player.total_activities,
                  sessions: player.total_sessions,
                  accuracy: player.average_accuracy * 1,
                  avg_time: { formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)` },
                });

                row++;

                if (player.courses.length) {
                  collapseRows.push({
                    start: row,
                    end: row + player.total_activities + player.total_sessions,
                    level: 2,
                  });

                  player.courses.forEach((course) => {
                    if (course.items.length) {
                      course.items.forEach((item) => {
                        avg_time = $filter('formatDuration')(item.stats.average_time).split(':');

                        worksheet.addRow({
                          name: `${item.name} (${$filter('courseItemType')(item.item_type)})`,
                          sessions: item.stats.total_sessions,
                          accuracy: item.stats.average_accuracy * 1,
                          avg_time: {
                            formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                          },
                        });

                        row++;

                        if (item.sessions.length) {
                          collapseRows.push({ start: row, end: row + item.sessions.length, level: 3 });
                          let sessionNumber = 1;

                          item.sessions.forEach((session) => {
                            avg_time = $filter('formatDuration')(session.time).split(':');

                            worksheet.addRow({
                              name: `Session ${sessionNumber}`,
                              accuracy: session.accuracy * 1,
                              avg_time:
                                session.time !== null
                                  ? {
                                    formula: `TIME(${avg_time[0]},${avg_time[1]},${avg_time[2]}) + INT(${avg_time[0]}/ 24)`,
                                  }
                                  : null,
                              date_created: session.date_created,
                            });

                            sessionNumber++;
                            row++;
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });

          collapseRows.forEach((collapseRow) => {
            for (let i = collapseRow.start; i < collapseRow.end; i++) {
              worksheet.getRow(i).outlineLevel = collapseRow.level;
            }
          });

          worksheet.getColumn(6).numFmt = '0.00%';
          worksheet.getColumn(7).numFmt = '[h]:mm:ss';

          worksheet.getRow(1).font = { bold: true };

          worksheet.views = [{ state: 'frozen', ySplit: 1 }];

          worksheet.properties.outlineProperties = {
            summaryBelow: false,
            summaryRight: false,
          };

          // save workbook to disk
          workbook.xlsx
            .writeBuffer({ base64: true })
            .then((xls64) => {
              // build anchor tag and attach file (works in chrome)
              const a = document.createElement('a');
              const data = new Blob([xls64], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });

              const url = URL.createObjectURL(data);
              a.href = url;
              a.download = reportService.generateReportFilename(
                `${$scope.viewmodel.hub.name} Journey Stats`,
                null,
                null,
                'xlsx',
              );
              document.body.appendChild(a);
              a.click();
              // eslint-disable-next-line angular/timeout-service
              setTimeout(() => {
                document.body.removeChild(a);
                // eslint-disable-next-line angular/window-service
                window.URL.revokeObjectURL(url);
              }, 0);
            })
            .catch((error) => {
              $log.log(error.message);
            });

          $scope.exporting = false;
        }, 0);
      },
      exportPrizeStats() {
        if (!$scope.viewmodel.playerPrizes.length) {
          return false;
        }

        // Pull all prize data to generate report, assume we only have the current pagination page.
        return hubService
          .getHubPrizes(
            $scope.data.hub_id,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            const reportData = [];

            reportData.push(['Player', 'Player ID', 'Level', 'Date Achieved', 'Prize Selected', 'Date Claimed']);

            for (let i = 0; i < response.length; i++) {
              reportData.push([
                `${response[i].first_name} ${response[i].last_name}`,
                response[i].username,
                response[i].level,
                tzService.parseFormatUserDate(response[i].date_created, 'YYYY-MM-DD HH:mm:ss'),
                response[i].prize_selected,
                response[i].date_selected !== null
                  ? tzService.parseFormatUserDate(response[i].date_selected, 'YYYY-MM-DD HH:mm:ss')
                  : '',
              ]);
            }

            return reportData;
          })
          .catch((err) => {
            throw err.data;
          });
      },
      exportSpinStats() {
        if (!$scope.viewmodel.spinData) {
          return false;
        }

        const reportData = [];

        reportData.push(['Small Steps', 'Large Steps', 'Nothing', 'Total Spins', 'Total XP']);

        reportData.push([
          $scope.viewmodel.spinData.total_small_steps,
          $scope.viewmodel.spinData.total_large_steps,
          $scope.viewmodel.spinData.total_nothing,
          $scope.viewmodel.spinData.total_spins,
          $scope.viewmodel.spinData.total_xp,
        ]);

        return reportData;
      },
      createRatingWorkbook(games, start, end) {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'The Training Arcade';

        // Overview
        const worksheet = workbook.addWorksheet('Overview');

        // add column headers
        const header = [
          { header: 'Activity Name', key: 'activity_name', width: 12 },
          { header: 'Activity Type', key: 'activity_type', width: 12 },
          { header: 'Total Ratings', key: 'total_ratings', width: 12 },
          { header: 'Average Rating', key: 'average_rating', width: 12 },
        ];

        worksheet.columns = header;

        for (let i = 0; i < games.length; i++) {
          const rowData = {
            activity_name: games[i].name,
            activity_type: $filter('activitySubtype')(games[i].activity_subtype),
            total_ratings: games[i].total_ratings ? games[i].total_ratings : 0,
            average_rating: games[i].average_rating ? $filter('number')(games[i].average_rating, 2) : 0,
          };

          worksheet.addRow(rowData);
        }

        worksheet.getRow(1).font = { bold: true };

        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        worksheet.properties.outlineProperties = {
          summaryBelow: false,
          summaryRight: false,
        };

        // save workbook to disk
        workbook.xlsx
          .writeBuffer({ base64: true })
          .then((xls64) => {
            // build anchor tag and attach file (works in chrome)
            const a = document.createElement('a');
            const data = new Blob([xls64], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = reportService.generateReportFilename('Arcade Rating Analytics', start, end, 'xlsx');
            document.body.appendChild(a);
            a.click();
            // eslint-disable-next-line angular/timeout-service
            setTimeout(() => {
              document.body.removeChild(a);
              // eslint-disable-next-line angular/window-service
              window.URL.revokeObjectURL(url);
            }, 0);
          })
          .catch((error) => {
            $log.log(error.message);
          });

        if ($scope.exporting) {
          $scope.exporting = false;
        }
      },
      exportRatingStats(noDate = false) {
        let startDate = $scope.viewmodel.dateRange.startDate
          ? $scope.viewmodel.dateRange.startDate.toISOString(true)
          : null;
        let endDate = $scope.viewmodel.dateRange.endDate ? $scope.viewmodel.dateRange.endDate.toISOString(true) : null;

        if (noDate) {
          startDate = endDate = null;
        }

        $scope.exporting = true;

        return hubService
          .getActivityStats($scope.data.hub_id, startDate, endDate, { ratings_only: true })
          .then((response) => {
            const ratings = [];

            response.forEach((game) => {
              if (game && game.activity_type_id === 1) {
                ratings.push(game);
              }
            });

            return $scope.actions.createRatingWorkbook(ratings, startDate, endDate);
          });
      },
      prizeDetails(prize) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/views/player-prize.html',
            controller: 'PlayerPrizeController',
            size: 'lg',
            backdrop: true,
            resolve: {
              prize() {
                return prize;
              },
            },
          })
          .result.catch(angular.noop);
      },
      playerDetails(player) {
        player.hub_id = $scope.data.hub_id;
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/views/hub-player.html',
            controller: 'HubPlayerController',
            size: 'lg',
            backdrop: true,
            resolve: {
              player() {
                return player;
              },
              required_fields() {
                return $scope.viewmodel.required_fields;
              },
            },
          })
          .result.catch(angular.noop);
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },

      generateReportFilename: reportService.generateReportFilename,
    };

    $scope.$on('$destroy', () => {
      ngIntroService.clear();
    });

    $scope.initialize();
  },
]);
